<template>
  <div>
    <posts-table
      :config="config"
    />
  </div>
</template>

<script>
import PostsTable from '@/views/owner-fb/poster/PostsTable'
import PostsTableConfig from './config/posts-table-config'

export default {
  components: {
    PostsTable,
  },
  data() {
    return {
      config: PostsTableConfig,
    }
  },
}
</script>
